"use client";

import { Dialog, type DialogProps } from "@tosize/ui";
import { Slot } from "radix-ui";
import type { ReactNode } from "react";
import { type CommandDialogType, useCommand } from "./Context";

interface DialogButtonProps extends Omit<DialogProps, "open" | "onOpenChange"> {
	currentDialog: CommandDialogType[];
}

export function CommandActiveDialog(props: DialogButtonProps) {
	const { children, ...remainingProps } = props;
	const { activeDialog, setActiveDialog, isDialogActive } = useCommand();

	if (props.currentDialog.every((dialog) => !isDialogActive(dialog))) {
		return null;
	}

	return (
		<Dialog
			open={activeDialog ? props.currentDialog.includes(activeDialog) : false}
			onOpenChange={() =>
				setActiveDialog(
					activeDialog && props.currentDialog.includes(activeDialog)
						? undefined
						: props.currentDialog.at(0),
				)
			}
			{...remainingProps}
		>
			{children}
		</Dialog>
	);
}

interface CommandActiveDialogSlotProps {
	dialog: CommandDialogType;
	children: ReactNode;
}

export function CommandActiveDialogSlot({ dialog, children }: CommandActiveDialogSlotProps) {
	const { activeDialog, setActiveDialog, isDialogActive } = useCommand();

	if (!isDialogActive(dialog)) {
		return null;
	}

	return (
		<Slot.Root onClick={() => setActiveDialog(activeDialog === dialog ? undefined : dialog)}>
			{children}
		</Slot.Root>
	);
}

interface ShowIfDialogActiveProps {
	dialog: CommandDialogType;
	children: ReactNode;
}

export function ShowIfDialogActive({ dialog, children }: ShowIfDialogActiveProps) {
	const { activeDialog } = useCommand();

	if (activeDialog !== dialog) {
		return null;
	}

	return children;
}
